<template>
    <div id="research">
        <div class="container py-4 text-dark">
            <p class="h1">Research</p>
            <div class="row row-cols-1 row-cols-xl-1 p-2">
                <div
                    class="col"
                    v-for="(publication, index) in publications"
                    :key="index"
                >
                    <div class="card bg-light mb-3 shadow research-card">
                        <div class="row">
                            <div class="col-12 col-lg-4">
                                <div
                                    :id="`carouselExampleIndicators${index}`"
                                    class="carousel slide mx-auto"
                                    data-ride="carousel"
                                    data-interval="false"
                                >
                                    <ol class="carousel-indicators">
                                        <li
                                            v-for="(image,
                                            index2) in publication.images"
                                            :key="index2"
                                            :data-target="`#carouselExampleIndicators${index}`"
                                            :data-slide-to="index2"
                                            :class="{ active: index2 == 0 }"
                                        ></li>
                                    </ol>

                                    <div class="carousel-inner">
                                        <div
                                            class="carousel-item"
                                            v-for="(image,
                                            index3) in publication.images"
                                            :key="index3"
                                            :class="{ active: index3 == 0 }"
                                        >
                                            <img
                                                class="d-block w-100 about-img m-2"
                                                :src="
                                                    require(`../img/research/${publication.imgSrc}/${image.link}`)
                                                "
                                                alt="First slide"
                                            />

                                            <div
                                                class="carousel-caption d-none d-md-block caption"
                                            ></div>
                                        </div>
                                    </div>
                                    <a
                                        class="carousel-control-prev"
                                        :href="`#carouselExampleIndicators${index}`"
                                        role="button"
                                        data-slide="prev"
                                    >
                                        <span
                                            class="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        ></span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a
                                        class="carousel-control-next"
                                        :href="`#carouselExampleIndicators${index}`"
                                        role="button"
                                        data-slide="next"
                                    >
                                        <span
                                            class="carousel-control-next-icon"
                                            aria-hidden="true"
                                        ></span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-12 col-lg-8">
                                <div class="card-body">
                                    <h5 class="card-title text-dark text-left">
                                        {{ publication.title }}
                                    </h5>
                                    <div readonly class="container textarea border rounded p-1 mb-3">
                                        <p
                                            class="card-text text-secondary text-left"
                                        >
                                            {{ publication.description }}
                                        </p>
                                    </div>

                                    <p class="card-footer">
                                        <a
                                            class="text-muted"
                                            :href="publication.link"
                                            target="_blank"
                                            >Read More
                                            <i
                                                class="fas fa-long-arrow-alt-right"
                                            ></i>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Research",
    data() {
        return {
            publications: [
                {
                    title:
                        "Targeting a Glioblastoma Cancer Stem-Cell Population Defined by EGF Receptor Variant III.",
                    imgSrc: "paper1",
                    images: [
                        {
                            link: "research1_0.jpg",
                        },
                        {
                            link: "research1_1.jpg",
                        },
                        {
                            link: "research1_2.jpg",
                        },
                    ],
                    description:
                        "The relationship between mutated proteins and the cancer stem-cell population is unclear. Glioblastoma tumors frequently express EGFRvIII, an EGF receptor (EGFR) variant that arises via gene rearrangement and amplification. However, expression of EGFRvIII is restricted despite the prevalence of the alteration. Here, we show that EGFRvIII is highly coexpressed with CD133 and that EGFRvIII(+)/CD133(+) defines the population of cancer stem cells (CSC) with the highest degree of self-renewal and tumor-initiating ability. This work demonstrates that a mutated oncogene can have CSC-specific expression and be used to specifically target this population.",
                    link: "https://pubmed.ncbi.nlm.nih.gov/24366881/",
                },
                {
                    title:
                        "EGFRvIII gene rearrangement is an early event in glioblastoma tumorigenesis and expression defines a hierarchy modulated by epigenetic mechanisms.",
                    imgSrc: "paper2",
                    images: [
                        {
                            link: "research2_0.png",
                        },
                        {
                            link: "research2_1.png",
                        },
                        {
                            link: "research2_2.png",
                        },
                    ],
                    description:
                        "Amplification and rearrangements of the epidermal growth factor receptor (EGFR) gene are frequently found in glioblastoma multiforme (GBM). The most common variant is EGFR variant III (EGFRvIII). Research suggests that EGFRvIII could be a marker for a cancer stem cell or tumor-initiating population. Collectively, this data demonstrates that EGFR amplification and rearrangement are early events in tumorigenesis and EGFRvIII follows a model of hierarchical expression. Furthermore, EGFRvIII expression is restricted by epigenetic mechanisms, suggesting that drugs that modulate the epigenome might be used successfully in glioblastoma tumors.",
                    link: "https://pubmed.ncbi.nlm.nih.gov/22797070/",
                },
                {
                    title:
                        "Expression of epidermal growth factor variant III (EGFRvIII) in pediatric diffuse intrinsic pontine gliomas",
                    imgSrc: "paper3",
                    images: [
                        {
                            link: "research3_0.jpg",
                        },
                        {
                            link: "research3_1.jpg",
                        },
                        {
                            link: "research3_2.jpg",
                        },
                    ],
                    description:
                        "Despite numerous clinical trials over the past 2 decades, the overall survival for children diagnosed with diffuse intrinsic pontine glioma (DIPG) remains 9-10 months. Radiation therapy is the only treatment with proven effect and novel therapies are needed. Epidermal growth factor receptor variant III (EGFRvIII) is the most common variant of the epidermal growth factor receptor and is expressed in many tumor types but is rarely found in normal tissue.We were therefore able to detect EGFRvIII expression in 6 of 11 DIPG cases. These data suggest that EGFRvIII warrants investigation as a target for these deadly pediatric tumors.",
                    link: "https://pubmed.ncbi.nlm.nih.gov/22382786/",
                },
                {
                    title:
                        "A novel epidermal growth factor receptor variant lacking multiple domains directly activates transcription and is overexpressed in tumors ",
                    imgSrc: "paper4",
                    images: [
                        {
                            link: "research4_0.jpg",
                        },
                        {
                            link: "research4_1.jpg",
                        },
                        {
                            link: "research4_2.jpg",
                        },
                    ],
                    description:
                        "The epidermal growth factor receptor (EGFR) is essential to multiple physiological and neoplastic processes via signaling by its tyrosine kinase domain and subsequent activation of transcription factors. EGFR overexpression and alteration, including point mutations and structural variants, contribute to oncogenesis in many tumor types. In this study, we identified an in-frame splice variant of the EGFR called mini-LEEK (mLEEK) that is more broadly expressed than the EGFR and is overexpressed in several cancers. These findings indicate that mLEEK levels determine cellular responses to unfavorable conditions that cause ER stress. This information, along with the overexpression of mLEEK in tumors, suggests unique strategies for therapeutic intervention. Furthermore, the identification of mLEEK expands the known mechanisms by which the EGFR gene contributes to oncogenesis and represents the first link between two previously disparate areas in cancer cell biology: EGFR signaling and the UPR.",
                    link: "https://pubmed.ncbi.nlm.nih.gov/21986942/",
                },
                {
                    title:
                        "Epidermal Growth Factor Receptor Variant III Contributes to Cancer Stem Cell Phenotypes in Invasive Breast Carcinoma",
                    imgSrc: "paper5",
                    images: [
                        {
                            link: "research5_0.jpg",
                        },
                        {
                            link: "research5_1.jpg",
                        },
                        {
                            link: "research5_2.jpg",
                        },
                    ],
                    description:
                        "EGFRvIII is a tumor-specific variant of the epidermal growth factor receptor (EGFR). Although EGFRvIII is most commonly found in glioblastoma, its expression in other tumor types remains controversial. In this study, we investigated EGFRvIII expression and amplification in primary breast carcinoma. Together, our findings show that EGFRvIII is expressed in primary breast tumors and contributes to CSC phenotypes in breast cancer cell lines through the Wnt pathway. These data suggest a novel function for EGFRvIII in breast tumorigenesis.",
                    link: "https://pubmed.ncbi.nlm.nih.gov/22419663/",
                },
            ],
        };
    },
};
</script>

<style scoped>
#research {
    background-color: #e9ecef;
}

.research-img {
    /* background-size: cover; */
    /* max-height: 500px; */
}

.research-card {
    /* height: 500px; */
}

.textarea{

    outline: none;
    max-height: 300px;
    overflow-y: auto;
    
    
}

/* .carousel-control-prev-icon,
.carousel-control-next-icon {
  height: 100px;
  width: 100px;
  outline: black;
  background-size: 100%, 100%;
  border-radius: 50%;
  border: 1px solid black;
  background-image: none;
}

.carousel-control-next-icon:after
{
  content: '>';
  font-size: 55px;
  color: red;
}

.carousel-control-prev-icon:after {
  content: '<';
  font-size: 55px;
  color: red;
} */

.carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23f00' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
}

.carousel-control-next-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23f00' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
}

.carousel-indicators li {
    /* background-color: #999; */
    background-color: black;
}

.carousel-indicators .active {
    background-color: red;
}
</style>